module.exports = __webpack_public_path__ + "static/media/chat-arrow-grow.06fc559b.png";